export const GAPI_API_KEY = "AIzaSyCvPwuyBeceJ1LZYUE5Hgz8fNDafaYTLxw";
export const GAPI_CLIENT_ID =
  "668768114307-9njdbpd1jc68ofeareg4q8ump4vhb8le.apps.googleusercontent.com";
export const GAPI_DISCOVERY_DOCS = [
  "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest",
];
export const GAPI_SCOPES =
  "https://www.googleapis.com/auth/drive.metadata.readonly";

export const GAPI_INIT_STATUS = {
  FAILURE: -1,
  INCOMPLETE: 0,
  SUCCESS: 1,
};
